import { defineAction } from '~/prix'
import { z } from 'zod'
import creditRequestCreateAction from './creditRequestCreate.action.json' with { type: 'json' }
import { creditRequestCreateInputObject, creditRequestObject } from '../creditRequestObject'

const creditRequestCreateDefinition = defineAction({
  ...creditRequestCreateAction,

  input: creditRequestCreateInputObject,
  output: z.object({
    id: creditRequestObject.shape.id,
    code: creditRequestObject.shape.code,
    estimatedBonusValue: creditRequestObject.shape.estimatedBonusValue,
  }),
})

export default creditRequestCreateDefinition

